import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useToast } from 'hooks/ui';
import { deleteTaskGroup } from 'api/task-groups.service';

export const useTaskGroupsDeleteQuery = () => {
  const toast = useToast();
  const queryClient = useQueryClient();

  const { isPending, isError, mutate } = useMutation({
    mutationFn: ({ id }: { id: string }) => deleteTaskGroup(id),

    onSuccess: (group) => {
      queryClient.invalidateQueries({ queryKey: ['taskGroups'] });
      deleteTaskGroup(group.id);
      toast.success('Group has been deleted successfully');
    },
    onError: (error: AxiosError) => {
      toast.error(error.message);
    },
    retry: false,
  });

  return { isLoading: isPending, isError, mutate };
};
